import React, { useEffect, useState } from "react";
import "./Personal_Info_Form.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import { Form } from "react-bootstrap";
import Select from "react-select";
import Common_Title_2 from "../common/common_components/common_title_2/Common_Title_2";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import Orange_Btn from "../common/common_btn/orange_btn/Orange_Btn";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import Successfull_Modal from "../common/modals/common-modal/successfull_modal/Successfull_Modal";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";


import {
  AllCity,
  AllCountry,
  AllGenders,
  AllPincode,
  AllState,
  EventFormStatus,
  EventRegistration,
  EventRegistrationValidation,
  SingleEvent,
} from "../../features/admin/common/Slice";
import useRazorpay from "react-razorpay";
import Pink_Btn from "../common/common_btn/pink_btn/Pink_Btn";
import Light_Black_Btn from "../common/common_btn/light_black_btn/Light_Black_Btn";
import AddParticipantModal from "./AddParticipantModal";
import { AllAppsetup } from "../../features/admin/footer/Slice";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import { decodeId, encodeId } from "../../utils/common";

const Personal_Info_Form = () => {
  const {
    control,
    reset,
    watch,
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const id = useParams();
  const navigate = useNavigate();
  const [successModal, setSuccessModal] = useState(false);
  const [unSuccessModal, setUnSuccessModal] = useState(false);
  const [message, setMessage] = useState(false);
  const [arrivalTime, setArrivalTime] = useState(null);
  const [departureTime, setDepartureTime] = useState(null);

  const dispatch = useDispatch();

  const eventForm = useSelector((state) => state.common.event_form_status);
  const event = useSelector((state) => state.common.event);
  const genders = useSelector((state) => state.common.all_genders);
  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_state);
  const cities = useSelector((state) => state.common.all_city);
  const pincodes = useSelector((state) => state.common.all_pincode);
  const maxCount = event?.Event?.participant_count || 0;

  const app_setup = useSelector((state) => state.footer.app_setup);

  useEffect(() => {
    dispatch(AllAppsetup());
  }, [dispatch]);

  const [participants, setParticipants] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const sendData = new FormData();

  useEffect(() => {
    dispatch(EventFormStatus());
    dispatch(AllCountry());
    dispatch(AllGenders());
  }, [dispatch]);

  useEffect(() => {
    if (id) dispatch(SingleEvent({ id: decodeId(id?.id) }));
  }, [id, dispatch]);

  const onSubmit = async (data) => {


    // console.log({ onSubmit: data });

    sendData.append("name", data?.full_name);
    sendData.append("dob", data?.dob);
    sendData.append("email", data?.email);
    sendData.append("address", data?.address);
    sendData.append("arrival_date", data.arrival_date);
    sendData.append("departure_date", data.departure_date);
    sendData.append("contact_no", data?.phone);
    sendData.append("alt_phone", data?.alt_phone);

    sendData.append("country_id", data?.country_id?.value);
    sendData.append("state_id", data?.state_id?.value);
    sendData.append("city_id", data?.city_id?.value);
    sendData.append("pincode_id", data?.pincode_id?.value);
    sendData.append("gender_id", data?.gender_id?.value);
    sendData.append("event_id", decodeId(id?.id));
    sendData.append("participants", JSON.stringify(participants));
    sendData.append("arrival_time", data.arrival_time);
    sendData.append("departure_time", data.departure_time);

    const participantCount =
      participants?.length > 0 ? participants.length + 1 : 1;

    const totalAmount = participantCount * Number(event?.Event?.price);
    sendData.append("program_fee", totalAmount);

    // for (let pair of sendData.entries()) {
    //   console.log(pair[0], pair[1]);
    // }

    const res = await dispatch(EventRegistrationValidation(sendData));

    if (res.meta?.requestStatus === "fulfilled") {
      if (res?.payload?.data?.allowed) {
        await handleRazorpay(totalAmount);
      }
    } else if (res.meta?.requestStatus === "rejected") {
      alert(`${res?.payload?.errors}`);
    }
  };

  const [Razorpay] = useRazorpay();
  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Khadyalay",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        // await setRazorId(res.razorpay_payment_id);
        finalFunction(res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9834474552",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const finalFunction = async (razorpay) => {
    for (let pair of sendData.entries()) {
      console.log(pair[0], pair[1]);
    }
    if (razorpay) {
      sendData.append("razorpay_id", razorpay);
      const res = await dispatch(EventRegistration(sendData));
      if (res.meta?.requestStatus === "fulfilled") {
        reset();
        setSuccessModal(true);
        setParticipants([]);
        setTimeout(() => {
          setSuccessModal(false);
          navigate(-1);
        }, 3000);
      } else if (res.meta?.requestStatus === "rejected") {
        alert(`${res?.payload?.errors}`);
      }
    } else {
    }
    for (let pair of sendData.entries()) {
      console.log(pair[0], pair[1]);
    }
  };
  const breadcrumbs = [
    { label: "EXPLORE", link: "/explore", active: false },
    {
      label: "SHIBIR & EVENT REGISTRATIONS",
      link: "/event-registration",
      active: false,
    },
    { label: event?.name, link: "", active: false },
  ];
  const isOn = (key) => eventForm?.[key] === true;

  const participantCount =
    participants?.length > 0 ? participants.length + 1 : 1;

  const totalAmount = participantCount * Number(event?.Event?.price);
  const arrivalDate = watch("arrival_date");
  // console.log({ errors, arrivalDate });
  useEffect(() => {
    setValue("departure_date", null);
  }, [arrivalDate]);

  return (
    <section className="Personal_Info_Form Volunteer_step_form">
      <div className="container">
        <Breadcrumb_Comp data={breadcrumbs} />

        <Common_Title_2 subText={"Personal Information"} />

        <div className="form_sec">
          <div className="row">
            <div className="col-lg-12 mx-auto">
              <Form>
                {/* <Common_Back_Header  /> */}
                <Common_Back_Header
                  backNavigation={`/shibir-registration/${encodeId(id?.id)}`}
                />
                <div className="row">
                  {isOn("full_name") && (
                    <div className="col-md-12 mb-3">
                      <div className="form-group">
                        <Form.Label>Full Name of Participant</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Full Name"
                          {...register("full_name", {
                            required: isOn("full_name")
                              ? "Full Name is required"
                              : false,
                            pattern: {
                              value: /^[A-Za-z.]+(?:\s[A-Za-z.]+)*$/,
                              message: "Enter a valid full name",
                            },
                          })}
                        />
                        {errors?.full_name && (
                          <Form.Text className="text-danger">
                            {errors.full_name.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("phone") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          placeholder="Phone Number"
                          type="text"
                          name="phone"
                          maxLength={10} // restrict typing to 10 digits
                          {...register("phone", {
                            required: isOn("phone")
                              ? "Phone Number is required"
                              : false,
                            pattern: {
                              value: /^[0-9]+$/, // only numbers
                              message: "Only digits are allowed",
                            },
                            minLength: {
                              value: 10,
                              message: "Phone Number must be exactly 10 digits",
                            },
                            maxLength: {
                              value: 10,
                              message: "Phone Number must be exactly 10 digits",
                            },
                          })}
                        />
                        {errors?.phone && (
                          <Form.Text className="text-danger">
                            {errors.phone.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("alt_phone") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Alternate Phone Number</Form.Label>
                        <Form.Control
                          placeholder="Alternate Phone Number"
                          type="text"
                          name="phone"
                          maxLength={10} // restrict typing to 10 digits
                          {...register("alt_phone", {
                            pattern: {
                              value: /^[0-9]+$/, // only numbers
                              message: "Only digits are allowed",
                            },
                            minLength: {
                              value: 10,
                              message:
                                "Alternate Phone Number must be exactly 10 digits",
                            },
                            maxLength: {
                              value: 10,
                              message:
                                "Alternate Phone Number must be exactly 10 digits",
                            },
                          })}
                        />
                        {errors?.alt_phone && (
                          <Form.Text className="text-danger">
                            {errors.alt_phone.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("gender") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Gender</Form.Label>
                        <Controller
                          name="gender_id"
                          control={control}
                          rules={{
                            required: isOn("gender")
                              ? "Gender is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={genders}
                              placeholder="Select Gender"
                            />
                          )}
                        />
                        {errors?.gender_id && (
                          <Form.Text className="text-danger">
                            {errors.gender_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {/* {isOn("dob") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Date of Birth</Form.Label>
                        <Controller
                          name="dob"
                          control={control}
                          rules={{
                            required: isOn("dob") ? "DOB is required" : false,
                          }}
                          render={({ field }) => (
                            <Flatpickr
                              {...field}
                              className="form-control" // 👈 makes it look Bootstrap
                              placeholder="Select Date of Birth"
                              options={{
                                dateFormat: "Y-m-d",        // backend safe
                                maxDate: "today",          // block future
                                altInput: true,
                                altFormat: "F j, Y",       // pretty UI
                                allowInput: false,        // prevent typing
                              }}
                              onChange={([date]) => field.onChange(date)}
                            />
                          )}
                        />
                        {errors?.dob && (
                          <Form.Text className="text-danger">
                            {errors.dob.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )} */}

                  {isOn("dob") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Date of Birth</Form.Label>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Controller
                            name="dob"
                            control={control}
                            rules={{
                              required: isOn("dob") ? "Date of Birth is required" : false,
                              validate: (value) => {
                                if (!value) return true;

                                const selectedDate = dayjs(value);
                                const today = dayjs().startOf("day");

                                if (selectedDate.isAfter(today)) {
                                  return "Future date is not allowed";
                                }

                                return true;
                              },
                            }}
                            render={({ field }) => (
                              <DatePicker
                                label="Select Date of Birth"
                                maxDate={dayjs().subtract(1, "day")}
                                value={field.value ? dayjs(field.value) : null}
                                onChange={(newValue) => {
                                  const formattedDate = newValue
                                    ? newValue.format("YYYY-MM-DD")
                                    : null;
                                  field.onChange(formattedDate);
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !!errors?.dob,
                                    helperText: errors?.dob?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>


                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Controller
                            name="dob"
                            control={control}
                            rules={{
                              required: isOn("dob") ? "DOB is required" : false,
                            }}
                            render={({ field }) => (
                              <DatePicker
                                label="Select Date of Birth"
                                placeholder="MM/DD/YYYY" // 👈 placeholder + display format
                                views={[" month", "day", "year"]}
                                maxDate={dayjs()} // disable future dates
                                value={field.value || null}
                                onChange={(newValue) => {
                                  // convert to YYYY-MM-DD for backend (same as input type="date")
                                  const formattedDate = newValue
                                    ? newValue.format("MM-DD-YYY")
                                    : null;

                                  field.onChange(formattedDate);
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    placeholder: "MM/DD/YYYY", // 👈 explicit placeholder
                                    error: !!errors?.dob,
                                    helperText: errors?.dob?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider> */}
                      </div>
                    </div>
                  )}
                  {isOn("email") && (
                    <div className="col-md-12 mb-3">
                      <div className="form-group">
                        <Form.Label>Email*</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email"
                          {...register("email", {
                            required: isOn("email")
                              ? "Email is required"
                              : false,
                            pattern: {
                              value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                              message: "Enter a valid email address",
                            }
                          })}
                        />
                        {errors?.email && (
                          <Form.Text className="text-danger">
                            {errors.email.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("country") && (
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <Form.Label>Country of Residence</Form.Label>
                        <Controller
                          name="country_id"
                          control={control}
                          rules={{
                            required: isOn("country")
                              ? "Country is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={countries}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                setValue("state_id", null);
                                setValue("city_id", null);
                                setValue("pincode_id", null);
                                dispatch(
                                  AllState({ countryId: selectedOption.value }),
                                );
                              }}
                              placeholder="Select Country"
                            />
                          )}
                        />
                        {errors?.country_id && (
                          <Form.Text className="text-danger">
                            {errors.country_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("state") && (
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <Form.Label>State</Form.Label>
                        <Controller
                          name="state_id"
                          control={control}
                          rules={{
                            required: isOn("state")
                              ? "State is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={states}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                setValue("city_id", null);
                                setValue("pincode_id", null);
                                dispatch(
                                  AllCity({ stateId: selectedOption.value }),
                                );
                              }}
                              placeholder="Select State"
                            />
                          )}
                        />
                        {errors?.state_id && (
                          <Form.Text className="text-danger">
                            {errors.state_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("city") && (
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <Form.Label>City</Form.Label>
                        <Controller
                          name="city_id"
                          rules={{
                            required: isOn("city") ? "City is required" : false,
                          }}
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={cities}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                setValue("pincode_id", null);
                                dispatch(
                                  AllPincode({ cityId: selectedOption.value }),
                                );
                              }}
                              placeholder="Select City"
                            />
                          )}
                        />
                        {errors?.city_id && (
                          <Form.Text className="text-danger">
                            {errors.city_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("pincode") && (
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <Form.Label>Postal Code</Form.Label>
                        <Controller
                          name="pincode_id"
                          control={control}
                          rules={{
                            required: isOn("pincode")
                              ? "Postal Code is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={pincodes}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                dispatch(
                                  AllPincode({ cityId: selectedOption.value }),
                                );
                              }}
                              placeholder="Select Code"
                            />
                          )}
                        />
                        {errors?.pincode_id && (
                          <Form.Text className="text-danger">
                            {errors.pincode_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}

                  {/* </div> */}
                  {isOn("address") && (
                    <div className="col-md-12 mb-3">
                      <div className="form-group">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          placeholder="Enter Address"
                          {...register("address", {
                            required: isOn("address")
                              ? "Address is required"
                              : false,
                          })}
                        />
                        {errors?.address && (
                          <Form.Text className="text-danger">
                            {errors.address.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {/* {isOn("arrival_date") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Date of Arrival*</Form.Label>
                        <Controller
                          name="arrival_date"
                          control={control}
                          rules={{
                            required: isOn("arrival_date")
                              ? "Arrival date is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Flatpickr
                              {...field}
                              className="form-control"
                              placeholder="Select arrival date"
                              options={{
                                dateFormat: "Y-m-d",
                                minDate: "today", // cannot select past
                              }}
                              onChange={([date]) => field.onChange(date)}
                            />
                          )}
                        />

                        {errors?.arrival_date && (
                          <Form.Text className="text-danger">
                            {errors.arrival_date.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )} */}

                  {isOn("arrival_date") && (
                    <div className="col-md-6 mb-3">
                      <Form.Group className="gray_input_group">
                        <Form.Label>Date of Arrival*</Form.Label>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Controller
                            name="arrival_date"
                            control={control}
                            rules={{
                              required: "Arrival date is required",
                              validate: (value) => {
                                if (!value) return true;

                                const selectedDate = dayjs(value);
                                const today = dayjs().startOf("day");

                                if (selectedDate.isBefore(today)) {
                                  return "Past date is not allowed";
                                }

                                return true;
                              },
                            }}
                            render={({ field }) => (
                              <DatePicker
                                label="Select Arrival Date"
                                minDate={dayjs()} // ✅ disable past dates
                                value={field.value ? dayjs(field.value) : null}
                                onChange={(newValue) => {
                                  const formattedDate = newValue
                                    ? newValue.format("YYYY-MM-DD")
                                    : null;
                                  field.onChange(formattedDate);
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !!errors?.arrival_date,
                                    helperText: errors?.arrival_date?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Form.Group>
                    </div>
                  )}


                  {isOn("arrival_time") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Time of Arrival*</Form.Label>
                        {/* <Form.Control
                          type="time"
                          {...register("arrival_time", {
                            required: isOn("arrival_time") ? "Arrival Time is required" : false,
                          })}
                        /> */}

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Controller
                            name="arrival_time"
                            control={control}
                            rules={{
                              required: isOn("arrival_time") ? "Arrival Time is required" : false,
                            }}
                            render={({ field, fieldState }) => (
                              <TimePicker
                                label="Select Arrival Time"
                                value={field.value || null}
                                onChange={(newValue) =>
                                  field.onChange(
                                    newValue ? newValue.format("HH:mm") : null
                                  )
                                }
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !!fieldState.error,
                                    helperText: fieldState.error?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>

                        {/* {errors?.arrival_time && (
                          <Form.Text className="text-danger">
                            {errors.arrival_time.message}
                          </Form.Text>
                        )} */}
                      </div>
                    </div>
                  )}


                  {isOn("departure_date") && (
                    <div className="col-md-6 mb-3">
                      <Form.Group className="gray_input_group">
                        <Form.Label>Date of Departure*</Form.Label>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Controller
                            name="departure_date"
                            control={control}
                            rules={{
                              required: "Departure date is required",
                              validate: (value) => {
                                if (!value) return true;

                                const selectedDate = dayjs(value);
                                const today = dayjs().startOf("day");

                                if (selectedDate.isBefore(today)) {
                                  return "Past date is not allowed";
                                }

                                return true;
                              },
                            }}
                            render={({ field }) => (
                              <DatePicker
                                label="Select Departure Date"
                                minDate={
                                  watch("arrival_date")
                                    ? dayjs(watch("arrival_date"))
                                    : dayjs()
                                } // ✅ cannot be before arrival
                                value={field.value ? dayjs(field.value) : null}
                                onChange={(newValue) => {
                                  const formattedDate = newValue
                                    ? newValue.format("YYYY-MM-DD")
                                    : null;
                                  field.onChange(formattedDate);
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !!errors?.departure_date,
                                    helperText: errors?.departure_date?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Form.Group>
                    </div>
                  )}

                  {isOn("departure_time") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Time of Departure*</Form.Label>
                        {/* <Form.Control
                          type="time"
                          {...register("departure_time", {
                            required: isOn("departure_time") ? "Departure Time is required" : false,
                          })}
                        /> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Controller
                            name="departure_time"
                            control={control}
                            rules={{
                              required: isOn("departure_time") ? "Departure Time is required" : false,
                            }}
                            render={({ field, fieldState }) => (
                              <TimePicker
                                label="Select Departure Time"
                                value={field.value || null}
                                onChange={(newValue) =>
                                  field.onChange(
                                    newValue ? newValue.format("HH:mm") : null
                                  )
                                }
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !!fieldState.error,
                                    helperText: fieldState.error?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>

                        {/* {errors?.departure_time && (
                          <Form.Text className="text-danger">
                            {errors.departure_time.message}
                          </Form.Text>
                        )} */}
                      </div>
                    </div>
                  )}
                  {isOn("agree_disclaimer") && (
                    <div className="col-md-12 mt-3 mb-3">
                      <div className="form-group">
                        <Form.Check
                          type="checkbox"
                          {...register("agree_disclaimer", {
                            required: isOn("agree_disclaimer")
                              ? "Not Agreed"
                              : 0,
                          })}
                          label="I acknowledge that this experience is for personal growth and is not a medical substitute."
                        />
                        {errors?.agree_disclaimer && (
                          <Form.Text className="text-danger">
                            {errors.agree_disclaimer.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  <p className="disclaimer_text">
                    <b>Disclaimer:</b> The practices and teachings offered
                    through this program are rooted in ancient yogic wisdom &
                    are intended to support personal well-being, spiritual
                    growth, & inner balance. They are not a substitute for
                    professional medical or psychological treatment.
                  </p>
                  {isOn("agree_non_refundable") && (
                    <div className="col-md-12 mt-1 mb-3">
                      <div className="form-group">
                        <Form.Check
                          type="checkbox"
                          {...register("agree_non_refundable", {
                            required: isOn("agree_non_refundable")
                              ? "Not Agreed"
                              : 0,
                          })}
                          label="I understand that this program is non-refundable once accessed."
                        />
                        {errors?.agree_non_refundable && (
                          <Form.Text className="text-danger">
                            {errors.agree_non_refundable.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("agree_guidelines") && (
                    <div className="col-md-12 mt-1 mb-3">
                      <div className="form-group">
                        <Form.Check
                          type="checkbox"
                          {...register("agree_guidelines", {
                            required: isOn("agree_guidelines")
                              ? "Not Agreed"
                              : 0,
                          })}
                          label="I agree to follow the spiritual & community guidelines during the program."
                        />
                        {errors?.agree_guidelines && (
                          <Form.Text className="text-danger">
                            {errors.agree_guidelines.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("agree_terms") && (
                    <div className="col-md-12 mt-1 mb-3">
                      <div className="col-md-12 mt-1 mb-3 checkbox_div">
                        <Form.Check
                          type="checkbox"
                          {...register("agree_terms", {
                            required: isOn("agree_terms") ? "Not Agreed" : 0,
                          })}
                        />
                        <span className="label_text">
                          I agree to the{" "}
                             <Link to={"/settings/terms-conditions"}>
                          <span className="link_text"> Terms & Conditions </span>{" "}
                             </Link>
                          and
                             <Link to={"/settings/privacy-policy"}>
                             <span className="link_text"> Privacy Policy </span>
                             </Link> .
                        </span>
                      </div>
                      {errors?.agree_terms && (
                        <Form.Text className="text-danger">
                          {errors.agree_terms.message}
                        </Form.Text>
                      )}
                    </div>
                  )}
                </div>
              </Form>

              <div className="pink_div">
                <div className="left_side_div">
                  <p className="black_text">Participant Count : {participants.length + 1 || "0"}</p>
                  <p className="black_text">Program Fee</p>
                  <p className="price_text">₹ {event?.Event?.price || "0"}</p>
                  <p className="black_text">Total Fee</p>
                  <p className="price_text">₹ {totalAmount || "0"}</p>
                </div>
                <div className="btn_holder d-flex gap-3">
                  {maxCount > 0 && (
                    <Light_Black_Btn
                      btnText="Add another participant"
                      disabled={participants.length >= maxCount}
                      onClick={() => setShowModal(true)}
                    />
                  )}

                  <Orange_Btn
                    btnText={"Continue"}
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </div>
          </div>

          <Successfull_Modal
            show={successModal}
            onHide={() => setSuccessModal(false)}
            headtext={"Event Registration"}
            successfultext={"Registered Successfully!"}
            subtext={"See You Soon!"}
            subtext2={"Have a nice time ahead"}
          />
          <AddParticipantModal
            app_setup={app_setup}
            event={event}
            show={showModal}
            onHide={() => setShowModal(false)}
            participants={participants}
            setParticipants={setParticipants}
            maxCount={maxCount}
          />
        </div>
      </div>
    </section>
  );
};

export default Personal_Info_Form;
